import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Theme, StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star'
import { RatingRange } from '../../common/constants';
import * as moment from 'moment';
import { Employee } from '../../common/models/CommonModels';
import { localizations } from '../../localization/localization';

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    starOff: {
        color: "#BBB"
    },
    starOn: {
        color: "orange"
    },
    paper: {
        padding: theme.spacing(3),
    },
    textBlock: {
        margin: `${theme.spacing(2)}px 0`
    },
    mailTo: {
        color: theme.palette.primary.main
    }
});

interface FeedbackBlockProps {
    feedbackDate: string;
    author: Employee;
    rating: RatingRange;
    feedbackText?: string;
    isRead: boolean;
    setRead: () => void;
}

type WithStylesProps = "starOn" | "starOff" | "paper" | "textBlock" | "mailTo";
type FeedbackBlockComponentProps = WithStyles<WithStylesProps> & FeedbackBlockProps

const dateFormat = "DD.MM.YYYY";
const timeFormat = "HH:mm";

const FeedbackBlock: React.SFC<FeedbackBlockComponentProps> = (props) => {
    const { classes, author, rating, feedbackText, isRead } = props;

    const date = moment(props.feedbackDate);

    return <Paper className={classes.paper}>
        <Grid container>
            <Grid item xs={1}>
                <Typography>{date.format(dateFormat)}</Typography>
                <Typography>{date.format(timeFormat)}</Typography>
            </Grid>
            <Grid item xs>
                <Grid container direction="column">
                    <Grid item>
                        <Grid container justify="space-between">
                            <Grid item>
                                <Grid container spacing={4}>
                                    <Grid item>
                                        <Typography><strong>{author.firstName} {author.lastName}, {author.company}</strong></Typography>
                                        <Typography><a className={classes.mailTo} href={"mailto: " + author.contact.email}>{author.contact.email}</a></Typography>
                                    </Grid>
                                    <Grid item>
                                        <StarIcon className={rating >= 1 ? classes.starOn : classes.starOff} />
                                        <StarIcon className={rating >= 2 ? classes.starOn : classes.starOff} />
                                        <StarIcon className={rating >= 3 ? classes.starOn : classes.starOff} />
                                        <StarIcon className={rating >= 4 ? classes.starOn : classes.starOff} />
                                        <StarIcon className={rating === 5 ? classes.starOn : classes.starOff} />
                                    </Grid>
                                    <Grid item>
                                        {isRead ? null : <Typography color="secondary">{localizations.common.new}</Typography>}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container alignItems="flex-start" justify="center">
                                    {!props.isRead ? (
                                        <Grid item>
                                            <Button variant="outlined" color="primary" onClick={() => props.setRead()}>
                                            {localizations.actions.markAsRead}
                                            </Button>
                                        </Grid>
                                    ) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {feedbackText ? <div>
                        <Divider />
                        <Grid item className={classes.textBlock}>
                            <Typography variant="body1">{feedbackText}</Typography>
                        </Grid> </div> : null}
                </Grid>
            </Grid>
        </Grid>
    </Paper>
}

export default withStyles(styles)(FeedbackBlock);


// WEBPACK FOOTER //
// ./src/admin/components/FeedbackBlock.tsx